import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-minimize-sidebar-button',
    templateUrl: './minimize-sidebar-button.component.html',
    styleUrls: ['./minimize-sidebar-button.component.scss'],
    standalone: false,
})
export class MinimizeSidebarButtonComponent {}
